import { render } from "./EmployeeCoiaDeclaration.vue?vue&type=template&id=07eec557&scoped=true"
import script from "./EmployeeCoiaDeclaration.vue?vue&type=script&lang=js"
export * from "./EmployeeCoiaDeclaration.vue?vue&type=script&lang=js"

import "./EmployeeCoiaDeclaration.vue?vue&type=style&index=0&id=07eec557&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07eec557"]])

export default __exports__